'use client';

import { useState, useEffect } from 'react';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Menu from './components/Menu';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Promo from './components/Promo';
import Projects from './components/Projects';
import PricesHero from './components/PricesHero';
import Prices from './components/Prices';
import PresaleProgress from './components/PresaleProgress';
import AnimatedShowcase from './components/AnimatedShowcase';
import Features from './components/Features';
import Roadmap from './components/Roadmap';
import Newsletter from './components/Newsletter';
import FAQ from './components/FAQ';
import Disclaimer from './components/Disclaimer';
import Footer from './components/Footer';
import Tokenomics from './components/Tokenomics';
import WalletConnect from './components/WalletConnect';
import TokenTermsLink from './components/TokenTermsLink';
import MouseTracker from './components/MouseTracker';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 8000); // 8 seconds for loader animation to complete

    return () => clearTimeout(timer);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <main>
     
      <Navbar toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <Menu isOpen={isMenuOpen} />
      
      <div className="container">
        <Hero />
        <Features />
        <About />
        <AnimatedShowcase 
          title="Pickles to GAM"
          description="PICKLES are reward points earned through gameplay and challenges. Convert your PICKLES to GAM to tap into even greater benefits, from enhanced rewards to advanced features within the platform."
          tag="Token Conversion"
          images={[
            'https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/4a5aa693-e5eb-40ae-2603-ef7b37a52f00/public',
            'https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/cf8e7728-cf09-4d73-0b7a-9575f8531000/public',
          ]}
        />
        <Tokenomics />
        <TokenTermsLink />
        <WalletConnect id="wallet-connect" />
        
        
        <div id="roadmap">
          <Roadmap />
        </div>
        <PricesHero />
        <Prices />
        <div id="faq">
          <FAQ />
        </div>
        <Newsletter />
      </div>
      <Disclaimer />
      <Footer />
    </main>
  );
}
